
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "KDCriteria",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/KDCriteria.vue